import { UserRolePermission } from '@src/types/settings';

export const canAccess = (
  permission: UserRolePermission | UserRolePermission[],
  permissions?: UserRolePermission[] | undefined
) => {
  let localPermissions: UserRolePermission[] | undefined;

  if (typeof window !== 'undefined') {
    const storedPermissions = localStorage.getItem('permissions');

    localPermissions = storedPermissions
      ? JSON.parse(storedPermissions)
      : undefined;
  }

  if (permissions) {
    if (Array.isArray(permission)) {
      return permission.some((perm) => permissions.includes(perm));
    } else {
      return permissions.includes(permission);
    }
  }

  if (localPermissions) {
    if (Array.isArray(permission)) {
      return permission.some((perm) => localPermissions.includes(perm));
    } else {
      return localPermissions.includes(permission);
    }
  }

  return false;
};

export const canEditOwnNote = (
  permission: UserRolePermission,
  permissions: UserRolePermission[] | undefined,
  userId: number | undefined,
  currentUserId: number | undefined
) => {
  if (!permissions) return false;

  return permissions.includes(permission) && userId === currentUserId;
};
